// /orgs/$orgSlug/ — the org landing page (read-only project list).
//
// Index child of the `orgs.$orgSlug` layout route; renders <OrgPage>
// exactly at the org root while sibling routes (projects, admin)
// replace it through the layout's <Outlet/>. Error handling lives on
// the parent layout's errorComponent.

import { createFileRoute } from '@tanstack/react-router';

import { OrgPage } from '../components/OrgPage';

export const Route = createFileRoute('/orgs/$orgSlug/')({
  component: OrgIndexRoute,
});

function OrgIndexRoute(): React.JSX.Element {
  const { orgSlug } = Route.useParams();
  return <OrgPage orgSlug={orgSlug} />;
}
